module.exports = __webpack_public_path__ + "img/mercedes.e862e09c.png";